module.exports = __webpack_public_path__ + "img/btn_systemPlatform.eacfb553.png";